/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    d="M14.75 3c0-1.5188-1.2312-2.75-2.75-2.75S9.25 1.4812 9.25 3 10.4812 5.75 12 5.75 14.75 4.5188 14.75 3ZM8.3338 4.6071a.75.75 0 1 0-.6676-1.3432A9.7882 9.7882 0 0 0 3.264 7.6662a.75.75 0 0 0 1.3433.6676A8.2883 8.2883 0 0 1 8.3338 4.607ZM16.3338 3.2639a.75.75 0 1 0-.6675 1.3432 8.2883 8.2883 0 0 1 3.7266 3.7267 8.1879 8.1879 0 0 1 .7398 2.2712l-1.2468-.7481a.75.75 0 0 0-.7718 1.2862l2.5001 1.5.5021.3013.4141-.4141 1.9999-2a.75.75 0 1 0-1.0606-1.0606l-.862.8619a9.6824 9.6824 0 0 0-.8716-2.6654 9.788 9.788 0 0 0-4.4023-4.4023ZM4.6072 15.6662a.75.75 0 0 0-1.0054-.3378.75.75 0 0 0-.3379 1.0054 9.7884 9.7884 0 0 0 4.4024 4.4023.75.75 0 0 0 .6676-1.3433 8.2878 8.2878 0 0 1-3.7267-3.7266ZM20.7361 16.3338a.75.75 0 0 0-.3378-1.0054.75.75 0 0 0-1.0054.3378 8.2879 8.2879 0 0 1-3.7266 3.7266.75.75 0 0 0 .6675 1.3433 9.788 9.788 0 0 0 4.4023-4.4023ZM12 18.25c1.5188 0 2.75 1.2312 2.75 2.75s-1.2312 2.75-2.75 2.75S9.25 22.5188 9.25 21s1.2312-2.75 2.75-2.75ZM3 14.75c1.5188 0 2.75-1.2312 2.75-2.75S4.5188 9.25 3 9.25.25 10.4812.25 12 1.4812 14.75 3 14.75Z"
  />,
  'MenuCDPipelinesFilled'
);
